import { render } from "./TvmAppointmentAddress.vue?vue&type=template&id=46231f46&scoped=true"
import script from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"
export * from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"

import "./TvmAppointmentAddress.vue?vue&type=style&index=0&id=46231f46&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46231f46"],['__file',"src/components/ChatWidget/SlideOutPanel/TvmAppointmentAddress/TvmAppointmentAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46231f46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46231f46', __exports__)) {
    api.reload('46231f46', __exports__)
  }
  
  module.hot.accept("./TvmAppointmentAddress.vue?vue&type=template&id=46231f46&scoped=true", () => {
    api.rerender('46231f46', render)
  })

}


export default __exports__